export const LOGIN_CONSTANTS = {
    // 平台类型。0-未知；1-PC网站；2-Android端；3-iOS端；4-管理员手动添加；5-Mac端；6-Windows端；7-小程序；8-移动端网站
    PLATFORM_PC: 1,
    PLATFORM_MOBILE_WEB: 8,
    PRODUCT_TYPE_VIEMAO: 120,
};
